<template>
  <div :class="layoutClass">
    <UtilMessage
      v-for="notification in $store.state.notifications.stickyList"
      :key="notification.id"
      @click.native="$store.commit('notifications/delete', notification.id)"
      :type="notification.type"
      name="sticky-message"
      class="mt-4 mb-2 mx-2 md:mx-0"
    >
      {{ notification.message }}

      <UtilTextLink v-if="notification.data && notification.data.link" :to="notification.data.link.path">
        {{ notification.data.link.text }}
      </UtilTextLink>
    </UtilMessage>

    <WidgetBreadcrumbs
      v-if="showBreadcrumbs && $route.meta.breadcrumb"
      :crumbs="$route.meta.breadcrumb"
      class="mt-4 mb-4"
    />

    <slot></slot>
  </div>
</template>

<script>
import UtilMessage from '@/components/utils/UtilMessage'
import UtilTextLink from '@/components/utils/UtilTextLink'
import WidgetBreadcrumbs from '@/components/widgets/WidgetBreadcrumbs'

export default {
  name: 'LayoutBaseContent',
  components: {
    UtilMessage,
    UtilTextLink,
    WidgetBreadcrumbs
  },
  props: {
    showBreadcrumbs: {
      type: Boolean,
      default: true
    },
    layoutClass: {
      type: String,
      default: 'sm:px-2 md:px-4 mx-auto sm:pb-16 sm:mt-4'
    }
  }
}
</script>
